import React from 'react';
import styled from 'styled-components';
import CheckedIcon from '../../assets/icons/icon_check.svg';

const Checkmark = styled.div`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: block;
    width: 100%;
    height: 100%;
    height: 16px;
    width: 16px;
    border-radius: 3px;
    border: 1px solid ${props => props.theme.colors.primary}

    ${props => props.size && props.size === 'sm' && `
        width: 14px;
        height: 14px;
    `}
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const Content = styled.div`
    margin-left: 24px;
    color: ${props => props.theme.colors.primary};
    font-weight: 500;

    &.disabled{
      color: #dddddd;
    }
`

const Container = styled.label`
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0;

    & input { 
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;

        &:checked ~ ${Checkmark} {
            background-color: ${props => props.theme.colors.primary};
            border-color: ${props => props.theme.colors.primary};
            background-image: url(${CheckedIcon});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 80%;

            &.primary {
                background-color: ${props => props.theme.colors.primary};
                border-color: ${props => props.theme.colors.primary};
            }

            &.disabled {
              opacity: 0.4;
              pointer-events: none;
            }
        }
    }
`

export class CheckboxHours extends React.PureComponent {

    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }


    componentDidMount() {
        // Preload checked icon
        new Image().src = CheckedIcon
    }

    click = (e) => {
        if (this.ref) {
            this.ref.current.click();
        }
    }

    handleChange = (e) => {
        const value = e.target.checked;
        if (this.props.onCheck) {
            this.props.onCheck({
                checked: value, 
                modality: this.props.modality,
                id: this.props.index
            });
        }
    }

    render() {
        return (
        <Container>
            <Wrapper>
                <input ref={this.ref} name={this.props.name} disabled={this.props.disabled} type={this.props.type || "checkbox"} checked={this.props.checked} onChange={this.handleChange} />
                <Checkmark size={this.props.size} className={[this.props.primary ? 'primary' : '', this.props.disabled ? 'disabled' : ''].filter(Boolean).join(' ')}/>
                <Content className={this.props.disabled ? 'disabled' : ''}>
                    {this.props.children}
                </Content>
            </Wrapper>
        </Container>
        )
    }
}
